import appIntegrations from './appIntegrations';
import featured from './featured';
import search from './search';
import { settings } from './setup';

export default {
  search,
  featured,
  appIntegrations,
  settings,
};
